import { render, staticRenderFns } from "./StudyModeModal.vue?vue&type=template&id=06452c6e&scoped=true&"
import script from "./StudyModeModal.vue?vue&type=script&lang=js&"
export * from "./StudyModeModal.vue?vue&type=script&lang=js&"
import style0 from "./StudyModeModal.vue?vue&type=style&index=0&id=06452c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06452c6e",
  null
  
)

export default component.exports